import { lazy, Suspense, useEffect, useState } from 'react';

const ScrollToTop = lazy(() =>
  import('@/components/layout/ScrollToTop').then(m => ({ default: m.ScrollToTop }))
);

/**
 * DeferredUI - Loads non-critical UI components after first paint
 */
export function DeferredUI() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  if (!mounted) return null;

  return (
    <Suspense fallback={null}>
      <ScrollToTop />
    </Suspense>
  );
}

export default DeferredUI;
